import { inject, Signal } from '@angular/core';
import { TranslationService } from '../translation.service';

export function translator(): (key: string) => Signal<string> {
  const service = inject(TranslationService);
  return (key: string) => service.translate(key)
}
